import BasePage from "@Scripts/Pages/BasePage";

export default class GlobalBikeProductListPage extends BasePage {
    public static async init() {
        await super.init();

        document.querySelector(".app-results").classList.remove("hden");
    }
}